import { Link } from "react-router-dom";
import {
  Siren,
  Waves,
  ClipboardCheck,
  Flame,
  Truck,
  HardHat,
  Factory,
  Package,
  GraduationCap,
  FlaskConical,
  Check,
  ArrowRight,
  TrendingUp,
  Building2,
} from "lucide-react";
import PageHero from "../components/PageHero";
import Reveal from "../components/Reveal";
import FlyerDownloadButton from "../components/FlyerDownloadButton";
import {
  spillContent,
  spillServices,
  roiOpportunities,
} from "../mock";

const iconMap = {
  Siren,
  Waves,
  ClipboardCheck,
  Flame,
  Truck,
  HardHat,
  Factory,
  Package,
  GraduationCap,
  FlaskConical,
};

export default function SpillSolutions() {
  return (
    <div>
      <PageHero kicker={spillContent.kicker} title={spillContent.title} image={spillContent.headerImage} />

      {/* Positioning */}
      <section className="py-20 bg-white">
        <div className="mx-auto max-w-[900px] px-6 text-center">
          <p className="font-heading uppercase tracking-[0.35em] text-[#1b75bc] text-sm mb-4">
            A Complete Solutions Partner
          </p>
          <h2 className="font-heading text-2xl md:text-3xl text-[#1a2540] leading-snug mb-8">
            A comprehensive solutions partner — not just a product supplier.
          </h2>
          <div className="w-14 h-[3px] bg-[#1b75bc] mx-auto mb-10" />
          <p className="text-[#6a6a6a] leading-relaxed mb-6">{spillContent.positioning}</p>
          <p className="text-[#6a6a6a] leading-relaxed">{spillContent.subPositioning}</p>
        </div>
      </section>

      {/* Services */}
      <section className="py-20 bg-[#f6f8fa]">
        <div className="mx-auto max-w-[1240px] px-6">
          <div className="text-center mb-16">
            <p className="font-heading uppercase tracking-[0.35em] text-[#1b75bc] text-sm mb-3">
              What We Offer
            </p>
            <h2 className="font-heading text-3xl md:text-4xl uppercase tracking-[0.08em] text-[#1a2540]">
              Our Service Programs
            </h2>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {spillServices.map((service, i) => {
              const Icon = iconMap[service.icon] || Package;
              return (
                <Reveal key={service.id} delay={(i % 3) * 80}>
                <div className="group msv-card h-full flex flex-col p-8">
                  <div className="flex items-center gap-4 mb-5">
                    <div className="msv-icon w-12 h-12 shrink-0">
                      <Icon size={22} />
                    </div>
                    <h3 className="font-heading text-lg uppercase tracking-[0.04em] text-[#1a2540] leading-tight">
                      {service.title}
                    </h3>
                  </div>

                  {service.intro && (
                    <p className="text-sm text-[#6a6a6a] mb-3">{service.intro}</p>
                  )}

                  <ul className="space-y-2.5 flex-1">
                    {service.items.map((item) => (
                      <li key={item} className="flex items-start gap-2.5">
                        <Check size={16} className="text-[#1b75bc] mt-0.5 shrink-0" />
                        <span className="text-sm text-[#4a4a4a]">{item}</span>
                      </li>
                    ))}
                  </ul>

                  {service.footnote && (
                    <p className="text-sm italic text-[#1b75bc] mt-4">{service.footnote}</p>
                  )}

                  {service.customers && (
                    <div className="mt-5 pt-4 border-t border-gray-100">
                      <span className="font-heading uppercase tracking-[0.08em] text-xs text-[#1a2540]">
                        Customers:
                      </span>
                      <p className="text-sm text-[#6a6a6a] mt-1">{service.customers}</p>
                    </div>
                  )}
                </div>
                </Reveal>
              );
            })}
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="py-20 bg-[#0f6b82]">
        <div className="mx-auto max-w-[820px] px-6 text-center">
          <h2 className="font-heading text-3xl uppercase tracking-[0.08em] text-white mb-5">
            Build a Spill Prevention Program
          </h2>
          <p className="text-white/80 leading-relaxed mb-8">
            Talk to Market Street Ventures about BoneDry service programs, scheduled deliveries,
            and custom absorbent solutions tailored to your facility.
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <Link
              to="/contact"
              className="inline-flex items-center gap-2 font-heading uppercase tracking-[0.2em] text-sm text-white border border-white/70 px-10 py-4 hover:bg-white hover:text-[#0f6b82] transition-all duration-300"
            >
              Get Started <ArrowRight size={16} />
            </Link>
            <FlyerDownloadButton product="spill" accent="#0c586b" accentHover="#09404f" />
          </div>
        </div>
      </section>
    </div>
  );
}
